import { render, staticRenderFns } from "./greenchain.vue?vue&type=template&id=4162caf0&scoped=true"
import script from "./greenchain.vue?vue&type=script&lang=js"
export * from "./greenchain.vue?vue&type=script&lang=js"
import style0 from "./greenchain.vue?vue&type=style&index=0&id=4162caf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4162caf0",
  null
  
)

export default component.exports